import React from "react";
import { NavLink } from "react-router-dom";
import { Gem, Swords, Castle, Timer, Settings } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../context/AuthContext";

export default function Sidebar() {
  const { t } = useTranslation();
  const { user, loginWithGoogle, logout } = useAuth();

  const linkBase =
    "flex items-center gap-3 px-4 py-2 rounded-lg transition-all cursor-pointer text-sm";

  // ❗ Dacă nu e logat → NU arătăm sidebar-ul
  if (!user) {
    return (
      <div className="w-full h-screen flex items-center justify-center bg-[#151515] text-gray-200">
        <div className="bg-[#1e1e26] p-8 rounded-2xl border border-gray-800 shadow-xl w-96 text-center">

          <h2 className="text-2xl font-bold text-purple-300 mb-4">
            Metin2Tools
          </h2>

          <p className="text-gray-300 text-sm mb-6">
            Conectează-te pentru a accesa trackerele Hydra, Meley, Guild și Timers.
          </p>

          <button
            onClick={loginWithGoogle}
            className="w-full bg-blue-600 hover:bg-blue-700 transition p-3 rounded-lg text-sm font-semibold"
          >
            Login cu Google
          </button>

        </div>
      </div>
    );
  }

  // ❗ Dacă e logat → sidebar normal
  return (
    <div className="w-64 h-screen bg-[#0f0f0f] text-gray-200 border-r border-gray-800 flex flex-col p-6 gap-4 fixed">

      <h1
        className="text-2xl font-bold text-purple-400 tracking-wide mb-4 cursor-pointer"
        onClick={() => (window.location.href = "/overview")}
      >
        Metin2Tools
      </h1>

      {/* 🔥 Navigație */}
      <nav className="flex flex-col gap-2 flex-1">
        <NavLink
          to="/"
          end
          className={({ isActive }) =>
            `${linkBase} ${
              isActive
                ? "bg-purple-900/50 text-purple-200"
                : "hover:bg-purple-900/40 hover:text-purple-200 text-gray-300"
            }`
          }
        >
          <Gem size={18} />
          <span>{t("sidebar.hydra")}</span>
        </NavLink>

        <NavLink
          to="/meley"
          className={({ isActive }) =>
            `${linkBase} ${
              isActive
                ? "bg-purple-900/50 text-purple-200"
                : "hover:bg-purple-900/40 hover:text-purple-200 text-gray-300"
            }`
          }
        >
          <Swords size={18} />
          <span>{t("sidebar.meley")}</span>
        </NavLink>

        <NavLink
          to="/guild"
          className={({ isActive }) =>
            `${linkBase} ${
              isActive
                ? "bg-purple-900/50 text-purple-200"
                : "hover:bg-purple-900/40 hover:text-purple-200 text-gray-300"
            }`
          }
        >
          <Castle size={18} />
          <span>{t("sidebar.guild")}</span>
        </NavLink>

        <NavLink
          to="/timers"
          className={({ isActive }) =>
            `${linkBase} ${
              isActive
                ? "bg-purple-900/50 text-purple-200"
                : "hover:bg-purple-900/40 hover:text-purple-200 text-gray-300"
            }`
          }
        >
          <Timer size={18} />
          <span>{t("sidebar.timers")}</span>
        </NavLink>

        <NavLink
          to="/settings"
          className={({ isActive }) =>
            `${linkBase} ${
              isActive
                ? "bg-purple-900/50 text-purple-200"
                : "hover:bg-purple-900/40 hover:text-purple-200 text-gray-300"
            }`
          }
        >
          <Settings size={18} />
          <span>{t("sidebar.settings")}</span>
        </NavLink>
      </nav>

      {/* 🔥 User info + logout */}
      <div className="mt-auto pt-4 border-t border-gray-800">
        <div className="flex flex-col items-center text-center">

          {/* AVATAR FIX • cu fallback • cu obiect-cover • cu container corect */}
          <div className="w-14 h-14 rounded-full mb-2 overflow-hidden border border-gray-700 shadow-md flex items-center justify-center bg-[#1a1a1a]">
            <img
              src={
                user.photoURL ||
                `https://ui-avatars.com/api/?name=${
                  encodeURIComponent(user.displayName || "User")
                }&background=4b5563&color=ffffff&size=128`
              }
              alt="avatar"
              className="w-full h-full object-cover"
              onError={(e) => {
                e.target.src = `https://ui-avatars.com/api/?name=${
                  encodeURIComponent(user.displayName || "User")
                }&background=4b5563&color=ffffff&size=128`;
              }}
            />
          </div>

          <p className="text-sm text-gray-300 mb-2 font-medium">
            {user.displayName}
          </p>

          <button
            onClick={logout}
            className="w-full bg-red-600 hover:bg-red-700 transition p-2 rounded-lg text-sm font-semibold"
          >
            Logout
          </button>
        </div>
      </div>

    </div>
  );
}
